module.exports = __webpack_public_path__ + "images/c2045cf1ff08e17999dcfe69876bcd0f.gif";